import { useMutation, useQueryClient } from '@tanstack/react-query';

import { endpoints } from 'global/endpoints';
import http from 'utils/http';

export interface IDeleteCFReportsTemplatesData {
  template_ids: Array<string>;
}

const deleteCFReportsTemplates = (postData: IDeleteCFReportsTemplatesData) => {
  return http().delete(endpoints.reports.customFieldsTemplates, postData);
};

export function useDeleteCFReportsTemplates() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: deleteCFReportsTemplates,
    onSettled: (data: any) => {
      if (data) {
        queryClient.invalidateQueries(['fetchPaginatedCFReportsTemplates']);
      }
    },
  });
}
